// mf-vap : comportements de la fiche cheminée vapeur V2.
// - Le choix de la variante reste celui du sélecteur NATIF du thème (prix, bouton panier, galerie se mettent à jour seuls).
// - Après chaque changement, on remplace nos blocs [data-mf-vap-maj] par ceux de la page renvoyée par Shopify.
// - Cartes formules, tableau des longueurs, « Choisir » du comparatif : cliquent le bouton natif correspondant
//   (sinon, le lien ?variant= recharge la page).
import { StandardEvents } from '@shopify/events';

const $$ = (s, r = document) => Array.prototype.slice.call(r.querySelectorAll(s));
const doux = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');

function entreeNative(option, valeur) {
  return $$('variant-picker input[data-option-name]').find(
    (i) => i.dataset.optionName.toLowerCase().indexOf(option) !== -1 && i.value === valeur
  );
}

function choisir(option, valeur) {
  const i = entreeNative(option, valeur);
  if (!i) return false;
  if (!i.checked) {
    $$('[data-mf-vap-maj="formules"], [data-mf-vap-maj="pour"]').forEach((n) => n.classList.add('charge'));
    i.click();
  }
  return true;
}

function majDepuis(html) {
  // une même clé peut exister plusieurs fois (ex. comparatif dans la fenêtre et dans la page) : remplacement dans l'ordre
  const vus = {};
  $$('[data-mf-vap-maj]', html).forEach((neuf) => {
    const cle = neuf.getAttribute('data-mf-vap-maj');
    const i = (vus[cle] = (vus[cle] === undefined ? 0 : vus[cle] + 1));
    const ancien = $$('[data-mf-vap-maj="' + cle + '"]')[i];
    if (!ancien) return;
    const tout = ancien.querySelector('.mfv-tab-l.tout');
    const copie = document.importNode(neuf, true);
    if (tout) { const t = copie.querySelector('.mfv-tab-l'); if (t) t.classList.add('tout'); }
    ancien.replaceWith(copie);
  });
  majBoutonTout();
}

// Fenêtre « Les 3 formules »
function fenetre() { return document.getElementById('mf-vap-comp-dlg'); }
function ouvrirComp() {
  const d = fenetre();
  if (!d) return false;
  if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
  return true;
}
function fermerComp() {
  const d = fenetre();
  if (!d) return;
  if (d.close) d.close(); else d.removeAttribute('open');
}

document.addEventListener(StandardEvents.productSelect, (e) => {
  if (!e.promise || (e.target && e.target.closest && e.target.closest('product-card'))) return;
  e.promise
    .then((r) => { if (r && r.detail && r.detail.html) majDepuis(r.detail.html); })
    .catch(() => {})
    .finally(() => $$('.charge').forEach((n) => n.classList.remove('charge')));
});

function majBoutonTout() {
  $$('[data-mfv-tout]').forEach((b) => {
    const t = b.parentNode.querySelector('.mfv-tab-l');
    b.textContent = t && t.classList.contains('tout') ? 'Masquer les autres longueurs' : 'Voir les 9 longueurs';
  });
}

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-mfv-comparer]')) {
    if (ouvrirComp()) e.preventDefault();
    return;
  }
  if (e.target.closest('[data-mfv-fermer]')) { fermerComp(); return; }
  const dlg = fenetre();
  if (dlg && e.target === dlg) { fermerComp(); return; } // clic sur le fond sombre
  const f = e.target.closest('[data-mfv-formule]');
  if (f) {
    if (choisir('formule', f.dataset.mfvFormule) || choisir('modèle', f.dataset.mfvFormule)) {
      e.preventDefault();
      if (f.closest('#mf-vap-comp-dlg')) {
        setTimeout(fermerComp, 250);
      } else if (f.hasAttribute('data-mfv-remonter')) {
        const z = document.querySelector('[data-mf-vap-maj="formules"]');
        if (z) z.scrollIntoView({ behavior: doux(), block: 'center' });
      }
    } else if (f.getAttribute('href') === '#') e.preventDefault();
    return;
  }
  const tr = e.target.closest('tr[data-mfv-l]');
  if (tr) { choisir('longueur', tr.dataset.mfvL + ' cm'); return; }
  const tout = e.target.closest('[data-mfv-tout]');
  if (tout) {
    const t = tout.parentNode.querySelector('.mfv-tab-l');
    if (t) t.classList.toggle('tout');
    majBoutonTout();
    return;
  }
  const vp = e.target.closest('[data-mfv-voir-plus]');
  if (vp) {
    const c = document.getElementById('mf-vap-carac');
    if (!c) return;
    e.preventDefault();
    const d = c.closest('details');
    if (d && !d.open) {
      const s = d.querySelector('summary');
      if (s) s.click(); else d.open = true;
    }
    setTimeout(() => (d || c).scrollIntoView({ behavior: doux(), block: 'start' }), 60);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  const tr = e.target.closest && e.target.closest('tr[data-mfv-l]');
  if (tr) { e.preventDefault(); choisir('longueur', tr.dataset.mfvL + ' cm'); }
});

// Sélecteur de couleurs : le curseur fond une image dans la suivante.
function initCouleurs(z) {
  if (z.dataset.pret) return;
  z.dataset.pret = '1';
  const calques = $$('.mfv-c-calque', z);
  const pastilles = $$('.mfv-pastille', z);
  const cur = z.querySelector('.mfv-curseur');
  const nom = z.querySelector('.mfv-c-nom');
  let noms = [];
  try { noms = JSON.parse(z.querySelector('[data-mfv-c-noms]').textContent); } catch (err) { noms = []; }
  if (!cur || !calques.length) return;
  const max = calques.length - 1;
  let raf = 0;
  function pose(val) {
    const v = Math.max(0, Math.min(max, val));
    cur.value = v;
    const a = Math.floor(v), t = v - a;
    calques.forEach((c, k) => {
      c.style.opacity = k === a ? 1 : k === a + 1 ? t : 0;
      if (k === a + 1 && t > 0) { const im = c.querySelector('img'); if (im) im.loading = 'eager'; }
    });
    const p = Math.round(v);
    if (nom && noms[p]) nom.textContent = noms[p];
    pastilles.forEach((b, k) => b.classList.toggle('on', k === p));
  }
  function anim(to) {
    cancelAnimationFrame(raf);
    const from = +cur.value, t0 = performance.now(), dur = doux() === 'auto' ? 1 : 300;
    const pas = (t) => { const q = Math.min(1, (t - t0) / dur); pose(from + (to - from) * (1 - Math.pow(1 - q, 2))); if (q < 1) raf = requestAnimationFrame(pas); };
    raf = requestAnimationFrame(pas);
  }
  pastilles.forEach((b) => b.addEventListener('click', () => anim(+b.dataset.i)));
  cur.addEventListener('input', () => { cancelAnimationFrame(raf); pose(+cur.value); });
  pose(0);
}

function init() {
  $$('[data-mfv-couleurs]').forEach(initCouleurs);
  majBoutonTout();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
